import classNames from 'classnames';
import React from 'react';

type Props = {
  className?: string,
  horizontal?: boolean,
  wrap?: boolean,
  children: React.ReactNode,
  align?: 'left' | 'right' | 'center'
};

class BoxLayout extends React.PureComponent<Props> {
  override render (): React.ReactNode {
    const { className, children, horizontal, wrap, align } = this.props;

    return (
      <div className={classNames(
        className,
        'esko_boxlayout',
        {
          'esko_boxlayout-wrap': wrap,
          esko_horizontal: horizontal,
          esko_alignleft: align === 'left',
          esko_alignright: align === 'right'
        }
      )}>
        {children}
      </div>
    );
  }
}

export default BoxLayout;
